export default __webpack_public_path__ + "static/media/logoMobile.f5edca06.svg";